var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(-821 -1526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    transform: "translate(821 1526)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(827 1532.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_002---Transfers",
    "data-name": "002---Transfers",
    transform: "translate(0 0.421)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    width: 48.357,
    height: 34.783,
    rx: 4,
    transform: "translate(0.357)",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.441,15H49.324v8.221H0V15H16.441Z",
    transform: "translate(0 5.195)",
    fill: "#3f5c6c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 2.969,
    cy: 2.545,
    rx: 2.969,
    ry: 2.545,
    transform: "translate(31.747 5.09)",
    fill: "#2fa8cc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 2.545,
    cy: 2.545,
    r: 2.545,
    transform: "translate(37.685 5.09)",
    fill: "#e64c3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(4.11 6.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M5.74,7.74H4.37A1.37,1.37,0,0,1,4.37,5H5.74a1.37,1.37,0,1,1,0,2.74Z",
    transform: "translate(-3 -5)",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M13.48,7.74H9.37A1.37,1.37,0,1,1,9.37,5h4.11a1.37,1.37,0,1,1,0,2.74Z",
    transform: "translate(-1.15 -5)",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M19.441,11.74H4.37A1.37,1.37,0,1,1,4.37,9H19.441a1.37,1.37,0,1,1,0,2.74Z",
    transform: "translate(-3 -3.52)",
    fill: "#35495e"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-2",
    "data-name": "Rectangle-path",
    width: 50.054,
    height: 36.48,
    rx: 4,
    transform: "translate(30.05 43.267)",
    fill: "#e64c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M38.441,47H71.324v8.221H22V47H38.441Z",
    transform: "translate(8.142 17.038)",
    fill: "#3f5c6c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    "data-name": "Oval",
    cx: 2.969,
    cy: 2.545,
    rx: 2.969,
    ry: 2.545,
    transform: "translate(61.44 48.357)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    "data-name": "Oval",
    cx: 2.545,
    cy: 2.545,
    r: 2.545,
    transform: "translate(67.379 48.357)",
    fill: "#2fa8cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M27.74,39.74H26.37a1.37,1.37,0,0,1,0-2.74h1.37a1.37,1.37,0,0,1,0,2.74Z",
    transform: "translate(9.252 13.337)",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M35.48,39.74H31.37a1.37,1.37,0,1,1,0-2.74h4.11a1.37,1.37,0,0,1,0,2.74Z",
    transform: "translate(11.103 13.337)",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M41.441,43.74H26.37a1.37,1.37,0,1,1,0-2.74H41.441a1.37,1.37,0,1,1,0,2.74Z",
    transform: "translate(9.252 14.817)",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M52.7,14.476H43.677l3.142-3.142A1.37,1.37,0,0,0,44.882,9.4l-5.48,5.48a1.37,1.37,0,0,0,0,1.937l5.48,5.48a1.37,1.37,0,0,0,1.937-1.937l-3.142-3.142H52.7a1.37,1.37,0,0,1,1.37,1.37V35.027a1.37,1.37,0,1,0,2.74,0V18.586a4.11,4.11,0,0,0-4.11-4.11Z",
    transform: "translate(14.434 2.979)",
    fill: "#3b97d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M24.41,51.583l-5.48-5.48a1.37,1.37,0,0,0-1.937,1.937l3.142,3.142H11.11a1.37,1.37,0,0,1-1.37-1.37V33.37a1.37,1.37,0,0,0-2.74,0V49.811a4.11,4.11,0,0,0,4.11,4.11h9.023l-3.142,3.142A1.37,1.37,0,1,0,18.929,59l5.48-5.48A1.37,1.37,0,0,0,24.41,51.583Z",
    transform: "translate(2.591 11.486)",
    fill: "#3b97d3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA7);
export default __webpack_public_path__ + "static/media/a7.1a43fc6192f38b39f89ee1bb9b9eaf82.svg";
export { ForwardRef as ReactComponent };